import React from "react";
import Nav from "./Components/navbar";
import Hero from "./Components/hero";
import Data from "./data";


export default function app() {


  const articles = Data.map((item) => {
      return (
        <Hero
          key={item.key}
          {...item}
        />
      );
    });

  return (
    <div>
      <Nav />
      <section className="articles-list">{articles}</section>
    </div>
  );
}

// const cards = Data.map((item) => {
//   return (
//     <Cards
//       key={item.key}
//       {...item}
//     />
//   );
// });
// return (
//   <div>
//     <Nav />
//     <Hero />
//     <section className="cards-list">{cards}</section>
//   </div>
// );